import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import LazyLoad from 'react-lazyload'

import { TestimoniesSectionContainer } from './style'

interface Testimonial {
  name: string
  location: string
  text: string
  image: string
  imageClass?: string
}

const testimonials: Testimonial[] = [
  {
    name: 'Megan & Jordan',
    location: 'Lisbon, Portugal',
    text: "We had a wedding for the history books and it was all made possible by Kiss & Tell! They brought our vision to life in less than a year, without visiting Portugal nor lifting a finger and made our magical 4 day wedding weekend smooth, allowing us to focus on being with family, friends, and exploring a new city with ease. Everything was spot on, as their passion and good taste, aligned with our goals, yielding amazing results. We're so fortunate to have avoided the wedding horrors everyone talks about by putting our trust in Kiss & Tell! We recommend them to any couple wanting to get married abroad. The Kiss & Tell team were truly amazing!",
    image: '/img/testimonies/MeganJordan.jpg',
  },
  {
    name: 'Laura & Ben',
    location: 'Lake Como, Italy',
    text: "We used Kiss & Tell to plan our Lake Como, Italy wedding, and they exceeded our expectations! In less than a month, they secured our venue, welcome party, farewell brunch, and boat tour provider. The wedding invites and website were sent out seamlessly, with the wedding portal being visually pleasing and easy for guests to navigate. Above all, the Kiss & Tell team was incredibly responsive, addressing our concerns within hours. Their services are unmatched! If you're considering a destination wedding, we can't recommend Kiss & Tell enough – they are absolutely amazing!",
    image: '/img/testimonies/LauraBen.jpg',
    imageClass: 'testimonial-laura-ben',
  },
  {
    name: 'David & Cindy (Parents of the Bride)',
    location: 'Costa Brava, Spain',
    text: "We are extremely happy with how Mackenzie & Spencer's wedding came out!  The Kiss & Tell team did a terrific job, and we agree, having support on site for those days and the wedding day was very helpful!",
    image: '/img/testimonies/DavidCindy.jpg',
    imageClass: 'testimonial-mackenzie-spencer',
  },
  {
    name: 'Summer & Pedro',
    location: 'Sintra, Portugal',
    text: "Finding Kiss & Tell was a huge lifesaver as we could see each property's event packages, customize them and select the actual hotel rooms that we needed for our group, with peace of mind that we received fair pricing!",
    image: '/img/testimonies/SummerPedro.jpg',
  },
  {
    name: 'Sara & Jean Paul',
    location: 'Riviera Maya, Mexico',
    text: "One year in and we're still in awe of the magic Kiss & Tell created for our wedding and getting everyone there. We couldn't imagine a more perfect setting in the world and having such a rock star celebration without their helpful guidance.",
    image: '/img/testimonies/SaraJeanPaul.jpg',
  },
  {
    name: 'Adriana & Cyril',
    location: 'Merida, Mexico',
    text: "With 170 guests traveling to our wedding, we knew there had to be a better way to manage our 4 room blocks and logistics connecting our group through the wedding day. Kiss & Tell's solution really made it possible for us to enjoy all of our guests the entire time.",
    image: '/img/testimonies/AdrianaCyril.jpg',
  },
  {
    name: 'Laura & Kevin',
    location: 'Fort Lauderdale, Florida',
    text: 'On our wedding day, we reveled in love as Kiss & Tell took on the challenges, seamlessly planning every detail and getting everyone there, just after a hurricane passed through. They went above and beyond, even collaborating on my wedding day looks via an intro and private NY Bridal Fashion Week showing with designer Justin Alexander.',
    image: '/img/testimonies/LauraKevin.jpg',
  },
  {
    name: 'Ken & Darin',
    location: 'Riviera Maya, Mexico',
    text: "We loved being Kiss & Tell's first couple, testing their venue marketplace and guest list tools and seeing their product come together with our feedback. Their concierges kept our wedding planning smooth and got our guests there!",
    image: '/img/testimonies/KenDarin.jpg',
  },
  {
    name: 'Dylan (Bridesmaid)',
    location: 'Sintra, Portugal',
    text: "When Summer invited us to her wedding on Kiss & Tell, it made total sense! I received updates, viewed the itinerary and my travel bookings while chatting with the other bridesmaids. Looking forward to my next friends' wedding on Kiss & Tell!",
    image: '/img/testimonies/Dylan.jpg',
  },
  {
    name: "It's All About (Photographer & Videographer)",
    location: 'Santorini, Greece',
    text: "We've shot many Kiss & Tell weddings but when they approached us 2 months out for a wedding in Santorini after the couple's local planner had quit, we thought they were crazy! Needless to say, they pulled off a magnificent wedding and welcome party and only we vendors knew it was down to the wire!",
    image: '/img/testimonies/AllAbout.jpg',
  },
]

const TestimoniesSection: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <TestimoniesSectionContainer
      fluid
      className={`testimonies-section ${className || ''}`}
    >
      <div className="section-content">
        <h2 className="fwl fz-35">What our clients say</h2>
        <span className="line bg-secondary mt-3 mb-3 mb-lg-5" />

        {testimonials.map((testimonial, index) => {
          const isEven = index % 2 === 0
          const imgClass = `testimonial-image ${testimonial.imageClass || ''}`

          return (
            <div
              key={`testimonial-${index.toString()}`}
              className="testimonial-wrapper Testimonials"
            >
              <Row className={`testimonial-row ${!isEven ? 'reverse' : ''}`}>
                <Col
                  xs={12}
                  md={3}
                  className={`image-col ${isEven ? 'even' : 'odd'}`}
                >
                  <LazyLoad height={150} once>
                    <Image
                      roundedCircle
                      className={imgClass}
                      src={testimonial.image}
                      alt={testimonial.name}
                    />
                  </LazyLoad>
                </Col>
                <Col
                  xs={12}
                  md={9}
                  className={`content-col ${isEven ? 'even' : 'odd'}`}
                >
                  <div className="content-wrapper">
                    <p className="testimonial-name">{testimonial.name}</p>
                    <p className="testimonial-location text-primary">
                      {testimonial.location}
                    </p>
                    <p className="testimonial-text">"{testimonial.text}"</p>
                  </div>
                </Col>
              </Row>
            </div>
          )
        })}
      </div>
    </TestimoniesSectionContainer>
  )
}

export default TestimoniesSection
